import { useState } from 'react'

import {
  EVENT_NAME_MOUSE_MOVE,
  EVENT_NAME_MOUSE_UP,
  EVENT_NAME_TOUCH_END,
  EVENT_NAME_TOUCH_MOVE,
} from '../../constants/event'
import { preventDefault } from '../../utils/events'

import { applyNextStyles, getComputedStyles } from './useResizable.utils'

export function useResizable(direction) {
  const [node, setNode] = useState(null)

  function setResizableRef(nodeElement) {
    setNode(nodeElement)
  }

  function handleMouseDown(event) {
    preventDefault(event)

    if (node) {
      const startPos = {
        x: event.clientX,
        y: event.clientY,
      }

      const { height, minHeight, minWidth, width } = getComputedStyles(node)

      function handleMouseMove(e) {
        const dx = e.clientX - startPos.x
        const dy = e.clientY - startPos.y

        applyNextStyles({
          direction,
          nextHeight: height + dy < minHeight ? minHeight : height + dy,
          nextWidth: width + dx < minWidth ? minWidth : width + dx,
          node,
        })
      }

      function handleMouseUp() {
        document.removeEventListener(EVENT_NAME_MOUSE_MOVE, handleMouseMove)
        document.removeEventListener(EVENT_NAME_MOUSE_UP, handleMouseUp)
      }

      document.addEventListener(EVENT_NAME_MOUSE_MOVE, handleMouseMove)
      document.addEventListener(EVENT_NAME_MOUSE_UP, handleMouseUp)
    }
  }

  function handleTouchStart(event) {
    if (node) {
      preventDefault(event)

      const touch = event.touches[0]
      const startPos = {
        x: touch.clientX,
        y: touch.clientY,
      }

      const { height, minHeight, minWidth, width } = getComputedStyles(node)

      function handleTouchMove(e) {
        const touch = e.touches[0]
        const dx = touch.clientX - startPos.x
        const dy = touch.clientY - startPos.y

        applyNextStyles({
          direction,
          nextHeight: height + dy < minHeight ? minHeight : height + dy,
          nextWidth: width + dx < minWidth ? minWidth : width + dx,
          node,
        })
      }

      function handleTouchEnd() {
        document.removeEventListener(EVENT_NAME_TOUCH_MOVE, handleTouchMove)
        document.removeEventListener(EVENT_NAME_TOUCH_END, handleTouchEnd)
      }

      document.addEventListener(EVENT_NAME_TOUCH_MOVE, handleTouchMove)
      document.addEventListener(EVENT_NAME_TOUCH_END, handleTouchEnd)
    }
  }

  return { handleMouseDown, handleTouchStart, setResizableRef }
}
